<!-- taro di parent kondisi nya -->
@if (packageDetailData) {
<div class="checkout">

    <!-- ORDER DETAIL -->
    <div class="checkout__detail">
        <div class="title">{{'checkout.title' | translate}}</div>
        <div class="wrap">
            <span class="bold">{{packageDetailData.name}}</span>
            <span class="regular">{{packageDetailData.price ?? 0 | currency}}</span>
        </div>
        <div class="activation__schedule">{{'checkout.activationSchedule' | translate}}</div>
        <button (click)="onClickRoamingDetail()">{{'checkout.detail' | translate}}</button>
        <div class="wrap">
            <span class="bold">{{'checkout.destinationNumber' | translate}}</span>
            <span class="regular">{{msisdn}}</span>
        </div>
        <span class="wrap">
            <span class="regular">{{'checkout.subtotal' | translate}}</span>
            <span class="bold">{{packageDetailData.price ?? 0 | currency}}</span>
        </span>
    </div>

    <!-- SUMMARY (DESKTOP ONLY) -->
    <div class="checkout__summary">
        <!-- Gada multi lang? -->
        <span class="title">{{'checkout.title' | translate}}</span>
        <div class="total__bill">
            <span class="label">{{'checkout.total' | translate}}</span>
            <span class="price">{{checkoutData()?.subTotalBill ?? 0 | currency}}</span>
        </div>
        <div class="bill__amount">
            <span class="label">{{'checkout.billAmount' | translate}}</span>
            <span class="price">{{checkoutData()?.totalBill ?? 0 | currency}}</span>
        </div>
    </div>

    <!-- FORM EMAIL -->
    <div class="checkout__email">
        <label for="Email">Email</label>
        <app-input-email (isValid)="isEmailValid.set($event)" [formControl]="email" [placeholder]="'user@email.com'" />
        <div class="description">{{'checkout.emailDesc' | translate}}</div>
    </div>

    <!-- SUBMIT -->
    <button class="checkout__payment-btn" (click)="createOrder()" [disabled]="!isEmailValid() || email.value === ''"
        [class.active]="isEmailValid() && email.value !== ''">{{'checkout.choicePayment' |
        translate}}
    </button>

    <!-- TNC -->
    <div class="checkout__tnc"
        [innerHTML]="'tnc' | translate : { url1: '/privacy-policy', url2: '/terms-and-conditions', classes: 'text-[#0050AE] font-poppins-bold' }">
    </div>
</div>
}@else {
<!-- loader ini taro di parent  -->
<shared-loader />
}
